import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {IonicModule} from '@ionic/angular';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {SelectManyFieldInputTypeHandlerComponent} from './select-many-field-input-type-handler.component';
import {
    MultipleSelectFilterModule
} from '../../../../../../modules/core/component/multiple-select-filter/multiple-select-filter.module';
import {
    MultipleSelectFilterSimpleModule
} from '../../../../../../modules/core/component/multiple-select-filter-simple/multiple-select-filter-simple.module';
import {ChipsComponent} from "../../../../../../modules/core/component/chips/chips.component";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        MultipleSelectFilterSimpleModule,
        ChipsComponent,
    ],
    declarations: [
        SelectManyFieldInputTypeHandlerComponent,
    ],
    exports: [
        SelectManyFieldInputTypeHandlerComponent,
    ],
})
export class SelectManyFieldInputTypeHandlerModule {}
